import React, { useEffect } from 'react';
import store from 'store';
import './Greeting.scss';
import { useTranslation, Trans } from 'react-i18next';
import { KEY } from 'utils/constants/storageKey';

const Greeting = ({ nickname, firstOpen, checkFirstOpen }) => {
  const { t } = useTranslation('main');
  const auth = store.get(KEY);

  useEffect(() => {
    if (firstOpen) {
      const timer = setTimeout(() => {
        checkFirstOpen();
      }, 2100);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [firstOpen, checkFirstOpen]);

  return (
    <div
      className={`greeting ${firstOpen ? '' : 'maxHeightZero'} ${
        JSON.parse(localStorage.getItem(KEY)) && !nickname ? 'hidden' : ''
      }`}
    >
      {!!nickname && auth.auth_type !== 'KB_USER' ? (
        <Trans
          t={t}
          i18nKey="shampoo.greeting"
          values={{ nickname: nickname }}
          components={{ div: <div /> }}
        />
      ) : (
        <Trans
          t={t}
          i18nKey="shampoo.greetingGuest"
          components={{ div: <div /> }}
        />
      )}
    </div>
  );
};

export default Greeting;
